import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

export const CloseButton = ( props ) => {

    // Construct the classes to use for the root component.
    const classes = classnames(
        'close-button',
        { 'disabled': Boolean( props.disabled ) },
        { [ props.className ]: Boolean( props.className ) },
    );
    
    return (
        <span
            className={ classes }
            style={ props.style }
            onClick={ props.onClick }
        >
            <img
                src="images/cross-01.svg"
                alt=""
            />
        </span>
    );
};

CloseButton.defaultProps = {
    className: undefined,
    style: undefined,
    disabled: false,
    onClick: undefined,
};

CloseButton.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};
